import React from "react";

interface AlertCircleIconProps {
    size?: number;
}

export default function AlertCircleIcon({ size = 14 }: AlertCircleIconProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                display: "block",
                background: "#FCFCFC",
                borderRadius: "50%"
            }}
        >
            <path
                d="M7 0.5C10.5899 0.5 13.5 3.41015 13.5 7C13.5 10.5899 10.5899 13.5 7 13.5C3.41015 13.5 0.5 10.5899 0.5 7C0.5 3.41015 3.41015 0.5 7 0.5ZM6.5 9.5V10.5H7.5V9.5H6.5ZM6.5 4.5V8H7.5V4.5H6.5Z"
                fill="#5C5C5C"
            />
        </svg>
    );
}